/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Sync status with retry information (used in sync_failed notifications).
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface SyncStatusWithRetry { 
    videoCallStatus: number;
    videoCallError: string;
    zohoCreatorStatus: number;
    zohoCreatorError: string;
    emailStatus: number;
    emailError: string;
    webhookStatus: number;
    webhookError: string;
    cancellationStatus: number;
    cancellationError: string;
    retryCount: number;
    isComplete: boolean;
    hasFailedSteps: boolean;
    nextRetryAt?: string | null;
    adminNotified: boolean;
}
export const SyncStatusWithRetry_videoCallStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_videoCallError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_zohoCreatorStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_zohoCreatorError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_emailStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_emailError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_webhookStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_webhookError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_cancellationStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_cancellationError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_retryCount_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_isComplete_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_hasFailedSteps_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatusWithRetry_nextRetryAt_Validators: ValidatorFn[] =
    [ ];

export const SyncStatusWithRetry_adminNotified_Validators: ValidatorFn[] =
    [  Validators.required, ];


